export namespace ArrowKeys {
  export interface API {
    setKeys(arrowEvents: ArrowKeys.ArrowEvents): void;
    resetKeys(): void;
  }

  export namespace Plugin {
    export const Name = 'arrowKeys';
  }

  export enum Arrow {
    Left = 'arrowleft',
    NumLeft = 'numpad4',
    Up = 'arrowup',
    NumUp = 'numpad8',
    Right = 'arrowright',
    NumRight = 'numpad6',
    Down = 'arrowdown',
    NumDown = 'numpad5',
  }

  export interface ArrowEvents {
    [ArrowKeys.Arrow.Left]?: () => void;
    [ArrowKeys.Arrow.Up]?: () => void;
    [ArrowKeys.Arrow.Right]?: () => void;
    [ArrowKeys.Arrow.Down]?: () => void;
  }
}
